export enum LanguageTypes {
    English = <any>'en-us',
    Spanish = <any>'es-es',
    Portuguese = <any>'pt-br',
    Basque = <any>'eu-es',
    French = <any>'fr-fr',
    Italian = <any>'it-it',
    German = <any>'de-de',

    Values = <any>[
        {
            id: English,
            name: 'English',
        },
        {
            id: Spanish,
            name: 'Español',
        },
        {
            id: Portuguese,
            name: 'Português',
        },
        {
            id: Basque,
            name: 'Euskera',
        },
        {
            id: French,
            name: 'Français',
        },
        {
            id: Italian,
            name: 'Italiano',
        },
        {
            id: German,
            name: 'Deutsch',
        },
    ],
}
